import React from "react";
import { Button } from "@mui/material";
import { COLORS, SettingButtonText } from "components";

export const ConsentManagement = () => {
  // review this function because it wasn't working even before the refactor
  const displayPreferenceModal = () => {
    (window as any)?.displayPreferenceModal();
    return false;
  };

  return (
    <Button
      onClick={displayPreferenceModal}
      variant="contained"
      sx={{
        color: "white",
        backgroundColor: COLORS.Romance,
        width: "242px",
        height: "36px",
        borderRadius: '8px'
      }}
    >
      <SettingButtonText>Consent Management</SettingButtonText>
    </Button>
  )
}